<div
  class="adf-people-widget {{field.className}}"
  [class.adf-invalid]="!field.isValid"
  [class.adf-readonly]="field.readOnly"
  id="people-widget-content"
>
  <mat-form-field>
    <label class="adf-label" [attr.for]="field.id"
      >{{field.name | translate }}<span *ngIf="isRequired()">*</span></label
    >
    <input
      #inputValue
      matInput
      class="adf-input"
      data-automation-id="adf-people-search-input"
      type="text"
      [id]="field.id"
      [formControl]="searchTerm"
      [placeholder]="field.placeholder"
      [attr.placeholder]="field.placeholder"
      [matAutocomplete]="auto"
      [title]="field.tooltip"
      [matTooltip]="field.tooltip"
      matTooltipPosition="above"
      matTooltipShowDelay="1000"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <span
      *ngIf="field.className === 'reassign-task-people-widget' && !inputValue.value"
      class="wk-visual-placeholder"
      >{{ field.placeholder }}</span
    >
    <mat-autocomplete
      class="adf-people-widget-list"
      #auto="matAutocomplete"
      (optionSelected)="onItemSelect($event.option.value)"
      [displayWith]="getDisplayName"
    >
      <mat-option
        *ngFor="let user of users$ | async; let i = index"
        [value]="user"
      >
        <div class="adf-people-widget-row" id="adf-people-widget-user-{{i}}">
          <div
            [outerHTML]="user | usernameInitials:'adf-people-widget-pic'"
          ></div>
          <div *ngIf="user.pictureId" class="adf-people-widget-image-row">
            <img
              id="adf-people-widget-pic-{{i}}"
              class="adf-people-widget-image"
              [alt]="getDisplayName(user)"
              [src]="peopleProcessService.getUserImage(user.id.toString()) | blobUrl: userImageBlobUrls: user | async"
            />
          </div>
          <span class="adf-people-label-name">{{getDisplayName(user)}}</span>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <error-widget
    *ngIf="isInvalidFieldRequired() && isTouched() && !isFocused; else error"
    required="{{ 'FORM.FIELD.REQUIRED' | translate }}"
  ></error-widget>
  <ng-template #error>
    <error-widget *ngIf="isTouched() && !isFocused" [error]="field.validationSummary"></error-widget>
  </ng-template>
</div>
